module.exports = __webpack_public_path__ + "img/238-thailand.1747b72c.svg";